module.exports = __webpack_public_path__ + "static/media/smile.f0f48e1c.svg";